import { VueEditor } from 'vue2-editor'
// import { Api } from '@/service';
import vSelect from 'vue-select';
import  codes from '@/codes';

//restful api
import { faq as board } from '@/service/api/board'

export default {
  components: { VueEditor, vSelect },
  data : () => ({ codes, confirm: false, add: false, lock: true, model : { type : '' }, category : { text : '', value : ''} }),
  methods: {
    cancel() { this.lock = true; },
    edit() { this.lock = false; },
    async remove() {
      try {
        // let rs = await Api.Manager_Call('board.faq', 'remove', { id : this.model.id });
        let rs = await board.deleteFaq({ id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          console.log("remove", 'failed', rs.reason, this.model.id)
          this.$toastr.e('remove', "failed")
        }
        this.list(); this.$emit('refresh')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      let check_id = '';
      
      check_id = this.model.id ? 'edit' : 'save';
      
      if(check_id == 'edit'){
        if(!(this.model.type || '').trim()) { return this.$toastr.e('Category is Require.'); }
      }else if(check_id == 'save'){
        if(!(this.model.type && this.model.type.value ? this.model.type.value : '').trim()) { return this.$toastr.e('Category is Require.'); }
      }
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is Require.'); }

      let model = this.model

      if(check_id == 'edit'){
        model.type = this.model.type
      }else if(check_id == 'save'){
        model.type = this.model.type.value
      }

      try {
        // let rs = await Api.Manager_Call('board.faq', this.model.id ? 'update' : 'insert', model);

        let check_id = '';
        check_id = this.model.id ? 'update' : 'insert'

        console.log(this.check_id = this.model.id ? 'update' : 'insert')

        if(check_id == 'update'){
          let rs = await board.updateFaq(model);
          if(!rs.error) {
            this.$toastr.s('Saved', this.$route.name);
            this.$emit("refresh")
            // this.$router.push({ name : 'board_faq', params : { id : rs.body.id } });
          } else {
            this.$toastr.s('Save', 'failed');
          }
        }else{
          let rs = await board.insertFaq(model);
          if(!rs.error) {
            this.$toastr.s('Saved', this.$route.name);
            this.$emit("refresh")
            // this.$router.push({ name : 'board_faq', params : { id : rs.body.id } });
          } else {
            this.$toastr.s('Save', 'failed');
          }
        }
        this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { 
      this.$router.push({ name: 'board_faq'});
    },
    async get({id, tag } = this.$route.params) {
      console.log('faq.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      // try { let rs = await  Api.Manager_Call('board.faq', 'detail', { id : id }); this.model = rs.body }
      try { let rs = await  board.detailFaq({ id : id }); this.model = rs.body }
      catch(e) { this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('faq.detail.vue', 'created'); },
  destroyed() { console.log('faq.detail.vue', 'destroyed'); },
  mounted() { console.log('faq.detail.vue', 'mounted'); this.get(this.$route.params); },
}